(() => {
  const menuSelector = '[data-ssc-menu]';

  function syncMenuState() {
    const anyMenuOpen = Array.from(document.querySelectorAll(menuSelector)).some((menu) => menu.open);
    document.body.classList.toggle('ssc-menu-open', anyMenuOpen);
  }

  function wireMenus(root = document) {
    root.querySelectorAll(menuSelector).forEach((menu) => {
      if (menu.dataset.sscWired === 'true') return;
      menu.dataset.sscWired = 'true';
      menu.addEventListener('toggle', syncMenuState);
    });
  }

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-ssc-menu-close]');
    if (closeButton) {
      closeButton.closest(menuSelector)?.removeAttribute('open');
      syncMenuState();
      return;
    }

    document.querySelectorAll('.ssc-policy-menu[open], .ssc-filter-menu[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${menuSelector}[open], .ssc-policy-menu[open], .ssc-filter-menu[open]`).forEach((details) => {
      details.removeAttribute('open');
    });
    syncMenuState();
  });

  document.addEventListener('DOMContentLoaded', () => wireMenus());
  document.addEventListener('shopify:section:load', (event) => wireMenus(event.target));
})();
